module.exports = __webpack_public_path__ + "e4e452602ee5672b3085bc26ea3dc2a0.MP3";